import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class VLangToggle extends Vue {
  @Prop() color!: string;
  value = "en";
  get backgroundStyles() {
    return {
      "gold-mid": this.value === "en",
      "gray-lighter": this.value === "bm",
    };
  }
  get indicatorStyles() {
    return {
      transform: this.value === "en" ? "translateX(14px)" : "translateX(0)",
    };
  }

  toggle() {
    if (this.value === "en") {
      this.value = "bm";
      this.$storage.setLanguage("bm");
    } else {
      this.value = "en";
      this.$storage.setLanguage("en");
    }
    this.$i18n.locale = this.value;
  }

  created() {
    const lang = this.$storage.getLanguage();
    if (!lang) {
      this.$storage.setLanguage("en");
    } else {
      this.value = lang;
    }
  }
}
